import { Button, Col, Input, Row, Select } from "antd";
import React from "react";
import { motivoIncidenciaArriboOpciones } from "../../../../constants/cons";
import { useIncidenciaForm } from "./useIncidenciaForm";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { startReporteDano } from "../../../../context/actions/incidenciasActions";

export const IncidenciasArribo = () => {
  const dispatch = useDispatch();
  const { asistenciaID } = useParams();
  const {asistencia} = useSelector((state) => state.detalleReducer);
  const { body, handleChange, handleSubmit } = useIncidenciaForm(2);
  const [danoPreexistente, setDanoPreexistente] = React.useState("");

  const handleSubmitDano = () => {
    if (!danoPreexistente.trim()) return;
    dispatch(startReporteDano({
      asistenciaID,
      descripcion: danoPreexistente
    }));
    setDanoPreexistente("");
  };

  if(asistencia.estatusID < 3) return <></>;

  const mostrarDanoPreexistente = asistencia.estatusID === 4 || asistencia.estatusID === 5;

  return (
    <Row gutter={5}>
      <Col span={mostrarDanoPreexistente ? 8 : 16}>
        <div className="inputLabel">Incidencia Arribo</div>
        <Select
          onChange={handleChange}
          value={body.motivoIncidenciaArribo}
          size="small"
          style={{ width: "100%" }}
          options={motivoIncidenciaArriboOpciones}
        />
      </Col>
      <Col span={mostrarDanoPreexistente ? 4 : 8} style={{ paddingTop: 22 }}>
        <Button onClick={handleSubmit} size="small" type="primary">
          Agregar
        </Button>
      </Col>
      {mostrarDanoPreexistente && (
        <>
          <Col span={8}>
            <div className="inputLabel">Daño Pre-existente</div>
            <Input
              value={danoPreexistente}
              onChange={(e) => setDanoPreexistente(e.target.value)}
              size="small"
              placeholder="Descripción del daño"
            />
          </Col>
          <Col span={4} style={{ paddingTop: 22 }}>
            <Button onClick={handleSubmitDano} size="small" type="primary">
              Agregar
            </Button>
          </Col>
        </>
      )}
    </Row>
  );
};
